import React from "react";
import ReactDOM from "react-dom/client";
import "./setup";
import App from "./App";
import supportedBrowsers from "../supportedBrowsers";
import "@politiet/sheriff-web-components";
import "@politiet/sheriff-css-framework";
import "leaflet/dist/leaflet.css";

if (!supportedBrowsers.test(navigator.userAgent)) {
  alert(
    "Nettleseren du bruker støttes ikke av denne nettsiden. \nVi anbefaler at du oppdaterer til en nyere versjon av nettleseren, eller bytter til en annen nettleser for å sikre optimal funksjonalitet.",
  );
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
